import { nexaApi } from './api';

function base64ToBytes(value) {
  const padded = value + '='.repeat((4 - (value.length % 4)) % 4);
  const raw = atob(padded.replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function enablePush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    throw new Error('Push not supported here. On iPhone: add NEXA to your Home Screen first, then open it from there.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission denied');

  const registration = await navigator.serviceWorker.register('/nexa-sw.js');
  await navigator.serviceWorker.ready;
  const { data } = await nexaApi.get('/push/key');
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64ToBytes(data.publicKey),
    });
  }
  await nexaApi.post('/push/subscribe', subscription.toJSON());
  return subscription;
}

export async function getPushStatus() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return 'unsupported';
  const registration = await navigator.serviceWorker.getRegistration('/nexa-sw.js');
  if (!registration) return 'off';
  const sub = await registration.pushManager.getSubscription();
  return sub ? 'on' : 'off';
}
